import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=087a5d30&scoped=true"
import script from "./relation.vue?vue&type=script&lang=js"
export * from "./relation.vue?vue&type=script&lang=js"
import style0 from "./relation.vue?vue&type=style&index=0&id=087a5d30&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a5d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087a5d30')) {
      api.createRecord('087a5d30', component.options)
    } else {
      api.reload('087a5d30', component.options)
    }
    module.hot.accept("./relation.vue?vue&type=template&id=087a5d30&scoped=true", function () {
      api.rerender('087a5d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/parameter_center/activity_type/components/relation.vue"
export default component.exports